<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="px-8 pt-8 register-tabs-container">
                              <div class="vx-card__title mb-4">
                                  <h4 class="mb-4">Create Account</h4>
                                  <p>Fill the below form to create a new account.</p>
                              </div>
                              <div class="clearfix">
                                <vs-input
                                  v-validate="'required|alpha_dash|min:3'"
                                  data-vv-validate-on="blur"
                                  label-placeholder="Name"
                                  name="name"
                                  placeholder="Name"
                                  v-model="input.full_name"
                                  class="w-full" />
                                <span class="text-danger text-sm">{{ errors.first('name') }}</span>

                                <vs-input
                                  v-validate="'required|email'"
                                  data-vv-validate-on="blur"
                                  name="email"
                                  type="email"
                                  label-placeholder="Email"
                                  placeholder="Email"
                                  v-model="input.email"
                                  class="w-full mt-6" />
                                <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                                <vs-input
                                  v-validate="'required|min:10|max:13'"
                                  data-vv-validate-on="blur"
                                  name="phone"
                                  type="text"
                                  label-placeholder="Phone Number"
                                  placeholder="Phone Number"
                                  v-model="input.phone"
                                  class="w-full mt-6" />
                                <span class="text-danger text-sm">{{ errors.first('phone') }}</span>

                                <vs-input
                                  v-validate="'required|min:3'"
                                  data-vv-validate-on="blur"
                                  name="username"
                                  type="text"
                                  label-placeholder="Username"
                                  placeholder="Username"
                                  v-model="input.username"
                                  class="w-full mt-6" />
                                <span class="text-danger text-sm">{{ errors.first('username') }}</span>

                                <vs-input
                                  ref="password"
                                  type="password"
                                  data-vv-validate-on="blur"
                                  v-validate="'required|min:6|max:10'"
                                  name="password"
                                  label-placeholder="Password"
                                  placeholder="Password"
                                  v-model="input.password"
                                  class="w-full mt-6" />
                                <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                <vs-input
                                  type="password"
                                  v-validate="'min:6|max:10|confirmed:password'"
                                  data-vv-validate-on="blur"
                                  data-vv-as="password"
                                  name="confirm_password"
                                  label-placeholder="Confirm Password"
                                  placeholder="Confirm Password"
                                  v-model="input.confirm_password"
                                  class="w-full mt-6" />
                                <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

                                <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms & conditions.</vs-checkbox>
                                <vs-button  type="border" to="/login" class="mt-6">Login</vs-button>
                                <vs-button id="submitBtn" class="float-right mt-6 mb-6 vs-con-loading__container" @click="doRegister" :disabled="!validateForm">Register</vs-button>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      input: {
        full_name: '',
        email: '',
        phone: '',
        username: '',
        password: '',
        confirm_password: '',
      },

      isTermsConditionAccepted: false,
      
      action: '',
      loading: true,
      notify: 'Server Error'
    }
  },

  computed: {
    validateForm () {
      return !this.errors.any() && this.input.full_name !== '' && this.input.email !== '' && this.input.phone !== '' && this.input.username !== '' && this.input.password !== '' && this.input.confirm_password !== '' && this.isTermsConditionAccepted === true
    }
  },

  methods: {
    reset() {
      Object.keys(this.input).map(item => {
        this.input[item] = ''
      })
    },
    doRegister () {      
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#submitBtn",
        scale: 0.45
      })

      let url = `${this.$api.endpoint}/register`
      this.$http.post(url, {
        username: this.input.username,
        full_name: this.input.full_name,
        password: this.input.password,
        password_confirmation: this.input.confirm_password,
        email: this.input.email,
        phone: this.input.phone
      }, {
        
      }).then(res => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")

        this.notify = res.data.message.split('_').join(' ')

        this.$router.push({ path: '/login'})
        this.reset()

        this.$vs.notify({
          title: 'Thank You',
          text: this.notify,
          color: 'success',
          position: 'top-right'
        })
      }).catch(error => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")
        this.$gf.httpErrorHandler(error)
      })
    }
  }
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
